export default {
    App: {
        'Automation support': 'Support à l’automatisation',
        'Contact Kalmar': 'Contacter Kalmar',
        'Create new': 'Créer nouveau',
        'Dealer community': 'Dealer community',
        'Download failed': 'Échec du téléchargement',
        'Failed to get service reports': 'Échec de l\'obtention des comptes-rendus d’entretien',
        'Kalmar Care service request': 'Demande de service Kalmar Care',
        'Kalmar Training Academy': 'Académie de formation Kalmar',
        'Kalmar Used Equipment': 'Occasions',
        'Loading MyKalmar': 'Chargement de MyKalmar',
        'Login again': 'Se reconnecter',
        'Maintenance reporting': 'Rapport d\'entretien',
        'Maintenance schedule': 'Maintenancier',
        'Manuals': 'Manuels',
        'My Cases': 'Mes cas',
        'MyKalmar homepage': 'Page d’accueil de MyKalmar',
        'MyParts': 'MyParts',
        'Navigating to MyParts failed': 'Échec de l’accès à MyParts',
        'No service reports found': 'Aucun compte-rendu d’entretien trouvé',
        'None': 'Aucun',
        'Open Dealer community': 'Communauté de distributeurs',
        'Open MyKalmar INSIGHT': 'Ouverture MyKalmar INSIGHT',
        'Open MyKalmar STORE': 'Ouvrir MyKalmar STORE',
        'Open used equipment sales portal': 'Ouvrir le portail de vente d\'équipements d\'occasion',
        'Parts order history': 'Historique des commandes',
        'Read more and subscribe': 'En savoir plus et s’abonner',
        'Read more and register': 'En savoir plus et s’inscrire',
        'Register Kalmar equipment': 'Enregistrer les équipements Kalmar',
        'Request training': 'Demande de formation',
        'Request service': 'Demande de service',
        'Show manuals search': 'Afficher la recherche de manuels',
        'Show all ({{ equipmentLength }}) equipment': 'Afficher tous les équipements ({{ equipmentLength }})',
        'Show all Kalmar contacts': 'Afficher tous les contacts Kalmar',
        'Show all cases': 'Afficher tous les cas',
        'Show on calendar': 'Afficher sur le calendrier',
        'Show requests': 'Afficher les demandes',
        'Try again': 'Réessayer',
        'You are now logged out from MyKalmar': 'Vous êtes maintenant déconnecté de MyKalmar',
        'Open TechSight': 'Ouvrez TechSight',
        'Solve smarter: your one-stop information source': 'Pensez malin : votre source d’information centralisée.',
    },
    BackToTop: {
        'Back to top': 'Retour en haut',
    },
    Banner: {
        'Boost driving skills and technical expertise with Kalmar Training Academy specialized training courses, designed to keep your team & equipment safe and reliable.': 'Renforcez les compétences de conduite et l\'expertise technique grâce aux cours de formation spécialisés de la Kalmar Training Academy, conçus pour garantir la sécurité et la fiabilité de votre équipe et de votre équipement.',
        'Check details for your equipment until they last.': 'Vérifiez les détails de votre équipement tant qu\'ils durent.',
        'Discover how to get the most out of your equipment.': 'Comment tirer le meilleur parti de votre engin.',
        'Ensure uptime, optimize your operations, and much more.': 'Garantissez la disponibilité, optimisez vos opérations et bien plus encore.',
        'Explore Kalmar Services': 'Découvrez nos services',
        'FLASH Sale is now on - Save up to 70%': 'La vente FLASH est maintenant en cours - Économisez jusqu\'à 70%',
        'Go to STORE': 'Aller au STORE',
        'Learn more': 'Apprendre encore plus',
        'Register in STORE now': 'Inscrivez-vous dès maintenant au STORE',
        'Selected Kalmar Genuine Parts now discounted in the MyKalmar STORE Outlet.': 'Des pièces d\'origine Kalmar sélectionnées sont désormais remisées dans le MyKalmar STORE Outlet.',
        'Take your team’s performance to the next level!': 'Faites passer les performances de votre équipe au niveau supérieur !',
    },
    BulletinsTab: {
        'Bulletin': 'Bulletin',
        'Bulletins': 'Bulletins',
        'Product': 'Produit',
        'Subject': 'Objet',
        'Date': 'Date',
        'Open pdf': 'Ouvrir le PDF',
        'Search bulletins': 'Rechercher des bulletins',
        'Select equipment': 'Sélectionner un équipement',
        'Category': 'Catégorie',
        'Select category': 'Sélectionner une catégorie',
        'No bulletins for your fleet.': 'Pas de bulletin disponible pour votre flotte.',
        'Bulletins are currently available for select equipment types only. We are actively expanding coverage to include the rest of your fleet in upcoming updates.': 'Les bulletins ne sont actuellement disponibles que pour certains types d\'équipements. Nous travaillons activement à étendre la couverture pour inclure le reste de votre flotte dans les prochaines mises à jour.',
        'Bulletins are visible to Kalmar internal users only.': 'Les bulletins ne sont visibles que par les utilisateurs internes de Kalmar.',
    },
    Common: {
        'All': 'Tous',
        'Language': 'Langue',
        'Select language': 'Sélectionner la langue',
        'Availability': 'Disponibilité',
        'Call the number': 'Appeler le numéro',
        'called': 'Appelé',
        'Cancel': 'Annuler',
        'Close': 'Fermer',
        'completed': 'Terminé',
        'Contracts': 'Contrats',
        'Customer number': 'Numéro du client',
        'declined': 'Refusé',
        'Description': 'Description',
        'Details': 'Détails',
        'Email': 'E-mail',
        'Maintenance': 'Maintenance',
        'Monthly': 'Tous les mois',
        'Monthly report': 'Rapport mensuel',
        'My Equipment': 'Mon équipement',
        'N/A': 'N/A',
        'Name': 'Nom',
        'No data': 'Pas de données',
        'No data for this time period': 'Pas de données pour cette période',
        'OK': 'Ok',
        'ordered': 'Commandé',
        'Other': 'Autre',
        'Other Equipment': 'Autre équipement',
        'Stock equipment': 'Équipement en stock',
        'Register Kalmar equipment': 'Enregistrer les équipements Kalmar',
        'Request submission failed': 'Échec de la soumission de la demande',
        'Response Time': 'Temps de réponse',
        'scheduled': 'Planifié',
        'See details': 'Voir les détails',
        'Send': 'Envoyer',
        'Serial number': 'Numéro de série',
        'Show on page': 'Vu sur la page',
        'Site': 'Site',
        'Something went wrong': 'Un problème est survenu',
        'Status': 'État',
        'today': 'aujourd\'hui',
        'Type': 'Type',
        'Unknown': 'Inconnu',
        'User': 'Utilisateur',
        'Yearly': 'Tous les ans',
        'Yearly trend': 'Tendance annuelle',
        'Search': 'Chercher',
        'Open': 'Ouvrir',
        'Welcome to MyKalmar': 'Bienvenue sur MyKalmar',

    },
    ContactWidget: {
        'Contact us!': 'Contactez-nous!',
        'Need help?  Or need to know more about our services?': 'Besoin d\'aide? Ou besoin d\'en savoir plus sur notre service ? ',
        'Phone': 'Téléphone',
        'Send email': 'Envoyer un email',
    },
    CustomerSelector: {
        'No results found with': 'Aucun résultat trouvé avec',
        'Search with name, city, street address or sold-to number': 'Search with name, city, street address or sold-to number',
        'Select customer': 'Sélectionner un client',
    },
    DataRequestForm: {
        'Acceptance of Data Notice': 'Acceptation de l’avis sur les données',
        'Company name': 'Nom de l’entreprise',
        'Contact us': 'Contactez-nous',
        'Data Act Notice': 'Avis sur la loi sur les données',
        'Data request sent': 'Demande de données envoyée',
        'Date of data concerned by the request': 'Date des données concernées par la demande',
        'Details': 'Détails',
        'Error sending data request:': 'Erreur lors de l’envoi de la demande de données :',
        'Fill request form': 'Remplir le formulaire de demande',
        'Form for data access request': 'Formulaire de demande d’accès aux données',
        'I have read and agree to the': 'J’ai lu et j’accepte',
        'Name': 'Nom',
        'No customer selected': 'Aucun client sélectionné',
        'Open comments': 'Commentaires ouverts',
        'Or alternatively,': 'Ou alternativement,',
        'Position/relationship with the Company': 'Poste/relation avec l’entreprise',
        'Products concerned by the request (e.g. serial number)': 'Produits concernés par la demande (ex. numéro de série)',
        'Something went wrong': 'Un problème est survenu',
        'Thank you for your data request': 'Merci pour votre demande de données',
        'Past data': 'Données passées',
        'Present data': 'Données actuelles',
        'Required data': 'Données requises',
        'Alternatively, please contact us at': 'Alternativement, veuillez nous contacter à',
    },
    DealerCommunity: {
        'Sales & general information': 'Ventes & Informations Générales',
        'Marketing & products': 'Marketing & Produits',
        'Technical library': 'Bibliothèque Technique',
        'News': 'Infos',
        'Kalmar contacts': 'Vos contacts Kalmar',
    },
    DocumentationTab: {
        'Manuals': 'Manuels',
        'Manual': 'Manuel',
        'Open': 'Ouvrir',
        'Select language': 'Choisir la langue',
        'See more manuals in other languages': 'Voir plus de manuels dans d’autres langues',
        'Search manuals with serial number': 'Recherche de manuels avec numéro de série',
    },
    EmptyWidgets: {
        'Buy genuine parts': 'Acheter des pièces d’origine',
        'By registering your equipment you can see manuals, contracts and more.': 'En enregistrant votre engin, vous pouvez consulter les manuels, les contrats et plus encore.',
        'Create a case': 'Créer un dossier',
        'Do you have an inquiry?': 'Vous avez une question à poser ?',
        'Description (serial numbers of all the equipment you want to register)': 'Description (numéros de série de tous les équipements que vous souhaitez enregistrer)',
        'Kalmar Services': 'Kalmar Services',
        'Performance management tool for cargo handling operations': 'Outil de gestion des performances pour les opérations de manutention',
        'Phone number': 'Numéro de téléphone',
        'Registration request received': 'Demande d’enregistrement reçue',
        'Thank you for your registration request. We will handle your request as soon as possible.': 'Merci pour votre demande d’enregistrement. Nous traiterons votre demande dès que possible.',
    },
    EquipmentAvailability: {
        'Equipment Type': 'Type d\'équipem.',
        'Month': 'Mois',
        'Quarter': 'Trimestre',
        'Year': 'Année',
    },
    EquipmentAvailabilityByType: {
        'Time spent': 'Temps écoulé',
    },
    Footer: {
        'General conditions': 'Conditions générales',
        'Kalmar in Social Media': 'Kalmar sur les réseaux sociaux',
        'Kalmar Digital Service Terms & Conditions': 'Conditions générales du service numérique Kalmar',
        'Privacy policy': 'Politique de confidentialité',
        'EU Data Act': 'Loi sur les données de l’UE',
        'For data questions, please contact': 'Pour toute question relative aux données, veuillez contacter',
    },
    KalmarInsightWidget: {
        'equipment': 'Équipement',
        'Expired license': 'Licence expirée',
        'License expiring soon': 'La licence va bientôt expirer',
        'Manage users': 'Gestion utilisateurs',
        'Number of MyKalmar INSIGHT users': 'Nombre d\'utilisateurs MyKalmar INSIGHT',
        'Valid license': 'Licence valide',
    },
    LanguageSelector: {
        'Select language': 'Choisir la langue',
    },
    LoadingFailure: {
        'Loading cases failed': 'Échec du chargement des cas',
        'Loading equipment availability failed': 'Échec du chargement de la disponibilité de l\'équipement',
        'Loading equipment failed': 'Échec du chargement de l’équipement',
        'Loading failed': 'Échec du chargement',
        'Loading maintenance schedule failed': 'Échec du chargement de la périodicité d’entretien',
        'Loading preventive maintenance data failed': 'Échec du chargement des données d’entretien préventif',
        'Loading response time failed': 'Échec du chargement du temps de réponse',
        'Loading sales orders failed': 'Échec du chargement des bons de commande',
        'Retry': 'Réessayer',
    },
    MaintenanceCalendar: {
        'Equipment name': 'Nom de l\'équipement',
        'Maintenance description': 'Description de l’entretien',
        'No maintenance scheduled for the selected day.': 'Aucun entretien planifié pour le jour sélectionné.',
    },
    MaintenanceReporting: {
        'Equipment Availability': 'Disponibilité de l’équipement',
        'Preventive Maintenance': 'Entretien préventif',
    },
    MaintenanceReportingWidget: {
        'Average duration from breakdown to the first service operation start': 'Average duration from breakdown to the first service operation start',
        'Average percentage the equipment was available': 'Pourcentage moyen de disponibilité de l’équipement',
        'Planned maintenance operations that were completed on time': 'Planned maintenance operations that were completed on time',
    },
    MaintenanceScheduleWidget: {
        'No upcoming maintenances': 'Aucun entretien à venir',
        'Upcoming maintenances': 'Entretiens à venir',
    },
    MasterHeader: {
        'Go to MyKalmar STORE or MyKalmar INSIGHT': 'Aller dans MyKalmar STORE or MyKalmar INSIGHT',
        'Language': 'Langue',
        'Log out': 'Déconnexion',
        'MyKalmar profile': 'MyKalmar Profil',
        'You can go to MyKalmar STORE and MyKalmar INSIGHT by clicking here': 'Vous pouvez aller dans MyKalmar STORE et MyKalmar INSIGHT en cliquant ici',
    },
    MyCasesWidget: {
        'An unknown value': 'Une valeur inconnue',
        'Automation': 'Automatisation',
        'Case': 'Cas',
        'changed from': 'changé de',
        'Comment': 'Commentaire',
        'n/a': 'n/a',
        'New comment': 'Nouveau commentaire',
        'No recent updates to cases': 'Aucune mise à jour récente des cas',
        'Priority': 'Priorité',
        'Recent updates': 'Mises à jour récentes',
        'Resolution_Date__c': 'Resolution date',
        'STORE': 'STORE',
        'to': 'à',
        'updated': 'mis à jour',
        'Updated at': 'Mis à jour le',
    },
    MyEquipment: {
        'Bulletins': 'Bulletins',
        'Contracts': 'Contrats',
        'Digital subscriptions': 'Abonnements numériques',
        'Documentation': 'Documentations',
        'Equipment details': 'Détails de l’équipement',
        'Equipment name': 'Nom de l’équipement',
        'MyKalmar INSIGHT': 'MyKalmar INSIGHT',
        'Leasing': 'Location',
        'Model': 'Modèle',
        'Search equipment with name, site, serial number or type': 'Rechercher un équipement par nom, site, numéro de série ou type',
        'Search with name, serial number or type': 'Rechercher par nom, numéro de série ou type',
        'Serial number': 'Numéro de série',
        'Short-term rental': 'Location courte durée',
    },
    MyEquipmentItem: {
        'Contract ends': 'Fin du contrat',
        'Contract started': 'Début du contrat',
        'No contracts': 'Aucun contrat',
        'Contact Kalmar for signing a contract': 'Contactez Kalmar pour signer un contrat',
        'Equipment details': 'Détails de l’équipement',
        'insight': 'MyKalmar INSIGHT',
        'leasing': 'Location',
        'Machine card': 'Carte machine',
        'maintenance': 'Maintenance',
        'Maintenance schedule': 'Périodicité d’entretien',
        'Manufacturing year': 'Année de fabrication',
        'Model': 'Modèle',
        'No data': 'Pas de données',
        'No equipment found': 'Aucun équipement trouvé',
        'Open': 'Ouvrir',
        'Order parts': 'Commander des pièces',
        'Owner': 'Propriétaire',
        'rental-short-term': 'Location courte durée',
        'Running hours': 'Heures de fonctionnement',
        'See Insights': 'Voir les aperçus',
        'Serial number': 'Numéro de série',
        'Today': 'Aujourd\'hui',
        'Preventive maintenance reports': 'Rapports de maintenance préventive',
        'No preventive maintenance reports': 'Aucun rapport de maintenance préventive',
        'Preventive maintenance reports are generated after certified Kalmar service inspections. Book a service inspection with our local team to keep your equipment running reliably.':
            "Chaque révision par notre service après-vente certifié Kalmar s'accompagne d'un rapport d'entretien préventif détaillé. Contactez votre équipe locale dès aujourd'hui pour planifier une intervention et assurer le bon fonctionnement de votre matériel",
        'Learn more about Kalmar maintenance': 'En savoir plus sur la maintenance Kalmar',
        'Learn more about Kalmar Care': 'En savoir plus sur Kalmar Care',
        'Maintenance records are temporarily unavailable': 'Les enregistrements de maintenance sont temporairement indisponibles',
        'Service order': 'Ordre de service',
        'Maintenance interval': 'Intervalle de maintenance',
        'Date': 'Date',
        'Faults': 'Défauts',
        'Comments': 'Commentaires',
        'View comments': 'Voir les commentaires',
        'Open pdf': 'Ouvrir le PDF',
        'Chapter': 'Chapitre',
        'Checkpoint': 'Point de contrôle',
        'Comment': 'Commentaire',
    },
    MyEquipmentWidget: {},
    MyPartsWidget: {
        'At warehouse': 'En entrepôt',
        'Customer PO': 'PO client',
        'Delivered': 'Livré',
        'My last parts orders': 'Mes dernières commandes de pièces',
        'No orders': 'Aucune commande',
        'Note: this order will be delivered in multiple shipments.': 'Remarque : Cette commande sera livrée en plusieurs envois.',
        'Order number': 'Numéro de commande',
        'Order received': 'Commande reçue',
        'Processing': 'En traitement',
        'Shipment': 'Envoi',
        'Shipped': 'Expédiée',
        'Tracking': 'Suivi',
        'Tracking information not available at the moment': 'Informations de suivi non disponibles pour le moment',
        'Not available': 'Non disponible',
        'Hide tracking': 'Masquer le suivi',
        'View tracking': 'Afficher le suivi',
        'Please wait for tracking information...': 'Veuillez patienter pour les informations de suivi...',
        'Est. Delivery': 'Livraison estimée',
    },
    NotFound: {
        'Go to home page': 'Aller à la page d’accueil',
        'Page not found': 'Page introuvable',
        'The page may have been moved or you may not have the necessary rights to access this page': 'La page a peut-être été déplacée ou vous ne disposez peut-être pas des droits nécessaires pour accéder à cette page',
    },
    PaginationTable: {
        "itemsCurrentlyShownText": "{{shownItemAmount}} de {{maxItemAmount}} affichés"
    },
    PreventiveMaintenanceCompletion: {
        'Completed': 'Terminé',
        'completed in': 'terminé dans',
        'Count': 'Nombre',
        'No data for': 'Pas de données pour',
        'Not completed': 'Non terminé',
        'Percentage': 'Pourcentage',
        'Planned': 'Planifié',
        'tasks': 'tâches',
    },
    ResponseTime: {
        'Action started': 'Action démarrée',
        'avg. response time': 'temps de réponse moy.',
        'Call started': 'Appel démarré',
        'in': 'in',
        'Operation': 'Utilisation',
        'Response time': 'Temps de réponse',
    },
    ServiceRequests: {
        'All': 'Tous',
        'Breakdown Maintenance': 'Dépannage',
        'Closed': 'Fermé',
        'Corrective Maintenance': 'Maintenance corrective',
        'Created': 'Créé',
        'Create new': 'Créer un nouveau',
        'Customer name': 'Nom du client',
        'Enter detailed description of the maintenance request...': 'Saisissez une description détaillée de la demande de maintenance...',
        'expertise, or swift troubleshooting.': 'expertise ou dépannage rapide.',
        'Fill request form': 'Remplir le formulaire de demande',
        'Maintenance type': 'Type de maintenance',
        'Mark request as complete': 'Marquer la demande comme terminée',
        'No customer selected': 'Aucun client sélectionné',
        'No service requests': 'Aucune demande de service',
        'Other Maintenance': 'Autres entretiens',
        'Request received': 'Demande reçue',
        'Request urgent repairs, additional maintenance': 'Demande de réparation urgente, de maintenance supplémentaire',
        'Phone number': 'Numéro de téléphone',
        'Preferred maintenance date (Kalmar cannot guarantee maintenance on this date)': 'Date de maintenance souhaitée (Kalmar ne peut pas garantir la maintenance à cette date)',
        'Preventive Maintenance': 'Maintenance préventive',
        'Search request': 'Demande de recherche',
        'Equipment location': 'Emplacement de l\'équipement',
        "This can't be changed": 'Ceci ne peut pas être modifié',
        'Thank you for your service request. We will contact you by phone as soon as possible during business hours.': 'Merci pour votre demande de service. Nous vous contacterons par téléphone dès que possible pendant les heures de bureau.',
        'Your reference': 'Votre référence'
    },
    SessionExpirationModal: {
        'Log in again': 'Reconnectez-vous',
        'You have been logged out due to inactivity': 'Vous avez été déconnecté pour cause d\'inactivité',
        'Your session has expired': 'Votre session a expiré',
    },
    SiteSelector: {
        'Customer': 'Client',
        'No sites with equipment': 'Aucun site avec équipement',
        'Select a customer': 'Sélectionner un client',
        'Selected': 'Sélectionné',
        'Show all sites': 'Montrer tous les sites',
        'Showing all sites': 'Affichage de tous les sites',
        'Recently visited': 'Visité récemment',
    },
    StockEquipment: {
        'Price': 'Prix',
        'Currency': 'Devise',
        'Please select a currency for the price': 'Veuillez sélectionner une devise pour le prix',
        'Contact email': 'E-mail de contact',
        'Added': 'Ajouté',
        'All': 'Tous',
        'Cancel': 'Annuler',
        'Close': 'Fermer',
        'Configuration number': 'Numéro de configuration',
        'Confirm': 'Confirmer',
        'Create stock equipment': 'Créer un équipement en stock',
        'Datasheet': 'Fiche technique',
        'Datasheets': 'Fiches techniques',
        'Delete': 'Supprimer',
        'Delete this equipment. This action can’t be undone.': 'Supprimer cet équipement. Cette action ne peut pas être annulée',
        'Description': 'Description',
        'Details': 'Détails',
        'Documents': 'Documents',
        'Edit': 'Modifier',
        'Engine type': 'Type de moteur',
        'Equipment added successfully': 'Équipement ajouté avec succès',
        'Equipment adding failed': 'Échec de l\'ajout de l\'équipement',
        'Estimated availability': 'Disponibilité estimée',
        'If you are interested in this equipment, please contact your local Kalmar sales representative or email us at': 'Si vous êtes intéressé par cet équipement, veuillez contacter votre représentant commercial Kalmar local ou nous envoyer un e-mail à',
        'Manufacturing year': 'Année de fabrication',
        'MAU location': 'Emplacement MAU',
        'Mark as active': 'Marquer comme actif',
        'Mark as inactive': 'Marquer comme inactif',
        'Mark as reserved': 'Marquer comme réservé',
        'Mark as sold': 'Marquer comme vendu',
        'Cancel reservation': 'Annuler la réservation',
        'Copy and create new': 'Copier et créer',
        'More options': 'Plus d’options',
        'ACTIVE': 'Actif',
        'INACTIVE': 'Inactif',
        'RESERVED': 'Réservé',
        'SOLD': 'Vendu',
        'Mark equipment as sold. This action can’t be undone.': 'Marquer cet équipement comme vendu. Cette action ne peut pas être annulée',
        'Model': 'Modèle',
        'No equipment found': 'Aucun équipement trouvé',
        'Picture': 'Photo',
        'Pictures': 'Photos',
        'Ready': 'Disponible',
        'Region': 'Région',
        'Regions': 'Régions',
        'Search equipment with name, serial number, description, model or site...': 'Rechercher un équipement par nom, numéro de série, description, modèle ou site...',
        'Search with name, serial number or description': 'Rechercher par nom, numéro de série ou description',
        'See all stock equipment ready to deliver': 'Voir tout l\'équipement en stock prêt à être livré',
        'Select equipment type': 'Sélectionner le type d\'équipement',
        'Select region': 'Sélectionner la région',
        'Send': 'Envoyer',
        'Show on page': 'Afficher par page',
        'Something went wrong': 'Une erreur s\'est produite',
        'Specification': 'Spécification',
        'Specifications': 'Spécifications',
        'Stock equipment details': 'Détails de l\'équipement en stock',
        'Type': 'Type',
        'Upload': 'Téléverser',
        'Picture is too large. Please upload a picture smaller than 8 MB.': 'La photo est trop grande. Veuillez téléverser une photo de moins de 8 Mo.',
        'Contact': 'Contact',
        'Stock equipment': 'Équipement en stock',
        'Show more': 'Afficher plus',
        'Show less': 'Afficher moins',
    },
    TimeUnitLinks: {
        'Show': 'Afficher',
    },
    Tooltips: {
        'Content': 'Content',
        'Recent reports': 'Recent reports',
    },
    TrainingRequests: {
        'All': 'Tous',
        'Closed': 'Fermé',
        'Created': 'Créé',
        'Create new': 'Créer un nouveau',
        'Customer name': 'Nom du client',
        'Eco Driving Training': 'Formation à la conduite écologique',
        'Enter detailed description of the training request...': 'Entrez une description détaillée de la demande de formation...',
        'Number of participants': 'Nombre de participants',
        'Operator Training': 'Formation des opérateurs',
        'Phone number': 'Numéro de téléphone',
        'Preferred time frame for training (Kalmar can’t guarantee training during this time frame, the training is reserved only after Kalmar has contacted you)': "Période souhaitée pour la formation (Kalmar ne peut garantir la formation pendant cette période, la formation est réservée seulement après avoir été contacté par Kalmar).",
        'Product Training': 'Formation sur les produits',
        'Reach out to one of our training specialists today.': 'Contactez dès aujourd’hui l’un de nos spécialistes de la formation.',
        'Receive hands-on training with heavy equipment and jobsite skills from industry professionals.': 'Bénéficiez d’une formation pratique sur les équipements lourds et les compétences sur chantier dispensée par des professionnels du secteur.',
        'Request received': 'Demande reçue',
        'Search training': 'Rechercher une formation',
        'Show requests': 'Afficher les demandes',
        'Technical Training': 'Formation technique',
        'Thank you for your training request. We will contact you by phone as soon as possible during business hours.': 'Merci pour votre demande de formation. Nous vous contacterons par téléphone dès que possible pendant les heures d’ouverture.',
        'Training type': 'Type de formation',
    },
};